// Overlapping circular avatar stack — social-proof primitive used in the
// landing hero (e.g. "50,000 viewers" with 3 face thumbnails).

import { cn } from "../cn.ts";

export interface AvatarStackProps {
  images: string[];
  size?: "sm" | "md";
  ringColorClass?: string; // e.g. "ring-white" or "ring-[var(--brand-pink)]"
  className?: string;
}

export function AvatarStack({
  images,
  size = "md",
  ringColorClass = "ring-white",
  className,
}: AvatarStackProps) {
  const sizePx = size === "sm" ? "h-7 w-7" : "h-9 w-9";
  return (
    <div className={cn("flex items-center -space-x-2", className)} aria-hidden>
      {images.map((src, i) => (
        <span
          key={i}
          className={cn(
            sizePx,
            "relative inline-block overflow-hidden rounded-full ring-2",
            ringColorClass,
          )}
        >
          <img src={src} alt="" className="h-full w-full object-cover" loading="lazy" />
        </span>
      ))}
    </div>
  );
}
